import { AuthContext } from '@/providers/AuthProvider/AuthContext';
import { useContext } from 'react';

export const useAuth = () => useContext(AuthContext);
